// @owners { team: patients-team }
import { ActionSheetContext, ActionSheetV2, LgPadding } from '@alto/design-system';
import { AddPaymentCard } from '@alto/features';
import React, { useContext } from 'react';

export type Props = {
  readonly onClose?: () => void;
};

export function CreditCardActionSheet({ onClose: handleClose }: Props) {
  const { closeActionSheet } = useContext(ActionSheetContext);
  const onClose = handleClose ?? closeActionSheet;

  return (
    <ActionSheetV2
      title="Add Credit Card"
      handleClose={onClose}
      analyticsName="credit card"
    >
      <LgPadding>
        <AddPaymentCard onClose={onClose} />
      </LgPadding>
    </ActionSheetV2>
  );
}
